
app.controller('voirCopieCtrl', function ($scope, toastr, services) {

	$scope.url_ = $rootScope.url_;

	$scope.choixPAGE = 3;

	$scope.init = function () {
		$scope.choixPAGE = 3;
		$scope.idqcm = "";
		$scope.code = "";
		$scope.copie = 0;

	};


	/******************************************************************************************************/
	$scope.login = function () {

		services.pdfCorrection({ id: $scope.idqcm, etud: $scope.code }).then(function (data) {

			if (data.data.mess == "erreur") {
				toastr.info('___Erreur de code___');
				$scope.copie = 0;
			} else if (data.data.mess == "pas de solution") {
				toastr.info('___Recommencez. Aucune copie ne correspond.___');
				$scope.copie = 0;
			} else {
				$scope.id = data.data.mess
				$scope.copie = 1
				toastr.info('___Votre copie a été trouvée___');
				toastr.info('___Cliquez sur le bouton bleu pour voir votre copie___');
			}

		});
		//1. chercher le numero de la copie qui correspond au code

		//2. copie l'image, mettre les cercle (vert, rouge, bleu + la note), créer un fichier pdf !

		//3. mettr eun lien sur _blank pour charger le fichier

		//4. si fichier sur plusieur pages -> faire les pages, créer un fichier pdf...

	}
	/******************************************************************************************************/

});




